import { getActiveInstance } from './ghlInstance';

const STORAGE_PREFIX = 'ghl_custom_values:';
const AUTO_COMMENT_SLOT_COUNT = 5;

const DEFAULT_SECTION_VISIBILITY = {
  commentDm: true,
  autoComments: true,
  checkoutRecovery: true
};

function cacheKey(locationId) {
  const id = String(locationId || getActiveInstance() || '').trim();
  return id ? `${STORAGE_PREFIX}${id}` : '';
}

function readEntry(locationId) {
  const key = cacheKey(locationId);
  if (!key) return null;

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch (err) {
    return null;
  }
}

function writeEntry(locationId, patch) {
  const key = cacheKey(locationId);
  if (!key) return;

  const current = readEntry(locationId) || {};
  try {
    localStorage.setItem(key, JSON.stringify(Object.assign({}, current, patch)));
  } catch (err) {
    // ignore storage quota / private-mode errors
  }
}

export function getCachedCommentDm(locationId) {
  const entry = readEntry(locationId);
  if (!entry || typeof entry.commentDm !== 'string') return null;
  return entry.commentDm;
}

export function getCachedAutoComments(locationId) {
  const entry = readEntry(locationId);
  const autoComments = entry && entry.autoComments;
  if (!Array.isArray(autoComments) || autoComments.length !== AUTO_COMMENT_SLOT_COUNT) {
    return null;
  }
  return autoComments.map(function (value) {
    return String(value || '');
  });
}

export function setCachedCommentDm(locationId, value) {
  writeEntry(locationId, { commentDm: String(value || '').trim() });
}

export function setCachedAutoComments(locationId, values) {
  if (!Array.isArray(values) || values.length !== AUTO_COMMENT_SLOT_COUNT) return;
  writeEntry(locationId, {
    autoComments: values.map(function (value) {
      return String(value || '').trim();
    })
  });
}

function normalizeSectionVisibility(raw) {
  if (!raw || typeof raw !== 'object') {
    return Object.assign({}, DEFAULT_SECTION_VISIBILITY);
  }
  return {
    commentDm: raw.commentDm !== false,
    autoComments: raw.autoComments !== false,
    checkoutRecovery: raw.checkoutRecovery !== false
  };
}

export function getCachedSectionVisibility(locationId) {
  const entry = readEntry(locationId);
  return normalizeSectionVisibility(entry && entry.sectionVisibility);
}

export function setCachedSectionVisibility(locationId, sectionVisibility) {
  writeEntry(locationId, {
    sectionVisibility: normalizeSectionVisibility(sectionVisibility)
  });
}

export function clearGhlCustomValuesCache() {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(function (key) {
    localStorage.removeItem(key);
  });
}
